<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-15 11:35:22
--> 
<template>
  <div>
    <staticResource></staticResource>
  </div>
</template> 
 
<script>
import staticResource from './staticResource.vue'
export default {
  components: {
    staticResource
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>